import './Styles.scss';

export class ContactForm {

    constructor(form) {
        this.form = form
        this.inputs = form.querySelectorAll('.form-control, .form-check-input')
        this.submit = this.form.querySelector('button[type="submit"]')

        this.form.addEventListener('submit', (event) => {
            event.preventDefault()

            this.submit.classList.add('btn-loading')
            setTimeout(() => {
                this.disableForm()
            }, 50)

            if(!this.validateForm()) {
                setTimeout(() => {
                    this.enableForm()
                }, 55)

                return
            }

            this.submitForm()
        })

        this.inputs.forEach((input) => {
            input.addEventListener('change', () => {
                this.validateInput(input)
            })
        })
    }

    disableForm = () => {
        this.inputs.forEach((input) => {
            input.disabled = true
        })

        this.submit.disabled = true
    }

    enableForm = () => {
        this.submit.classList.remove('btn-loading')

        this.inputs.forEach((input) => {
            input.disabled = false
        })

        this.submit.disabled = false
    }

    submitForm = () => {
        let data = new FormData(this.form)
        let XMLHttp = new XMLHttpRequest()

        XMLHttp.onreadystatechange = () => {
            if (XMLHttp.readyState === XMLHttpRequest.DONE && XMLHttp.status === 200) {
                let response = JSON.parse(XMLHttp.responseText)
                let feedback = this.form.querySelector('.form__feedback')

                feedback.innerText = response.data

                if (response.success) {
                    feedback.classList.add('form__feedback--success')

                    // Trigger form submit event
                    window.dataLayer = window.dataLayer || []
                    window.dataLayer.push({
                        'event':     data.get('frm_variant') + '_form_submit',
                        'recipient': data.get('frm_rec')
                    })
                } else {
                    feedback.classList.add('form__feedback--danger')
                }
            }
        }

        XMLHttp.addEventListener('loadend', () => {
            this.submit.classList.remove('btn-loading')
        })

        data.append('action', 'contact_form')

        XMLHttp.open('POST', ajaxURL, true)
        XMLHttp.send(data)
    }

    validateForm = () => {
        let isValid = true

        this.inputs.forEach((input) => {
            if (!this.validateInput(input)) {
                isValid = false
            }
        })

        return isValid
    }

    validateInput = (input) => {
        let group = input.closest('.form-group')
        let isValid = true
        let type = input.getAttribute('type')

        // Check required group
        if (group.classList.contains('form-group--is-required') && !(input.value)) {
            isValid = false
        }

        if (input.classList.contains('as-field') && input.value) {
            isValid = false
            alert('Opravdu jste člověk?')
        }

        // Required checkbox validation
        if (group.classList.contains('form-group--is-required') && type === 'checkbox') {
            if (!input.checked) {
                isValid = false
            }
        }

        // Check input type
        if (input.value) {
            switch (type) {
                case 'file':
                    if (input.dataset.allowedSize && input.files[0].size > input.dataset.allowedSize) {
                        isValid = false
                    }

                    if (input.dataset.allowedType) {
                        const types = input.dataset.allowedType.split(',')
                        const fileNameSplit = input.files[0].name.split('.')

                        if (!types.includes(fileNameSplit[fileNameSplit.length - 1])) {
                            isValid = false
                        }
                    }
                    break
                case 'email':
                    if (!this.validateEmail(input.value)) {
                        isValid = false
                    }
                    break
            }
        }

        if (!isValid) {
            group.classList.add('form-group--is-invalid')
        } else {
            group.classList.remove('form-group--is-invalid')
        }

        return isValid
    }

    validateEmail = (value) => {
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

        return re.test(value)
    }
}

window.addEventListener('load', function() {
    const contactForms = document.querySelectorAll('.contact-form')

    Array.from(contactForms).forEach((form, index) => {
        new ContactForm(form)
    })
})